import { render } from "./AdminRiderrateCreate.vue?vue&type=template&id=0bce3cd0&scoped=true&ts=true&lang=true"
import script from "./AdminRiderrateCreate.vue?vue&type=script&lang=ts"
export * from "./AdminRiderrateCreate.vue?vue&type=script&lang=ts"

import "./AdminRiderrateCreate.vue?vue&type=style&index=0&id=0bce3cd0&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bce3cd0"]])

export default __exports__